export default __webpack_public_path__ + "static/media/biobankki-logo.1f5c8ab0.png";